import type { ScoringRules, UserAnswer, Question } from '@examflow/core';

/**
 * SIELE 评分规则
 * SIELE 使用 0-1000 分制
 */
export const sieleScoringRules: ScoringRules = {
  totalScore: 1000, // 总分 1000
  passingScore: 600, // 通常 600 分以上为合格
  calculateScore: (answers: UserAnswer[], questions: Question[]): number => {
    if (questions.length === 0) return 0;

    const correctCount = answers.filter((a) => a.isCorrect).length;
    const accuracy = correctCount / questions.length;

    // 将正确率映射到 SIELE 0-1000 分制
    const score = Math.round(accuracy * 1000);

    return Math.min(1000, Math.max(0, score));
  },
};
